var _style, _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _path14, _path15, _path16, _g3, _g4, _g5, _circle, _ellipse, _circle2, _g6, _g7, _g8, _g9, _g10, _g11, _path17, _path18, _rect2, _path19, _rect3, _rect4, _path20, _polygon, _polygon2, _path21, _rect5, _circle3, _rect6, _circle4, _path22, _rect7, _polygon3, _rect8, _polygon4, _path23, _path24, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 291.4 268.5",
    style: {
      enableBackground: "new 0 0 291.4 268.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C0E0F9;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:#E0F0FF;}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{opacity:0.4;fill:#DBAEFA;}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{opacity:0.4;fill:#8260DE;}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:url(#SVGID_7_);}\n\t.st11{fill:url(#SVGID_8_);}\n\t.st12{fill:url(#SVGID_9_);}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:url(#SVGID_11_);}\n\t.st15{fill:url(#SVGID_12_);}\n\t.st16{fill:#7DCEFF;}\n\t.st17{fill:#0023FF;}\n\t.st18{fill:#FFFEFF;}\n\t.st19{fill:url(#SVGID_13_);}\n\t.st20{fill:url(#SVGID_14_);}\n\t.st21{fill:url(#SVGID_15_);}\n\t.st22{fill:url(#SVGID_16_);}\n\t.st23{fill:url(#SVGID_17_);}\n\t.st24{fill:#8261DF;}\n\t.st25{fill:none;stroke:url(#SVGID_18_);stroke-width:4.4424;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st26{fill:url(#SVGID_19_);}\n\t.st27{fill:url(#SVGID_20_);}\n\t.st28{fill:url(#SVGID_21_);}\n\t.st29{fill:url(#SVGID_22_);}\n\t.st30{fill:url(#SVGID_23_);}\n\t.st31{fill:url(#SVGID_24_);}\n\t.st32{fill:url(#SVGID_25_);}\n\t.st33{fill:url(#SVGID_26_);}\n\t.st34{fill:url(#SVGID_27_);}\n\t.st35{fill:url(#SVGID_28_);}\n\t.st36{fill:#DCA7F9;}\n\t.st37{fill:#CEE8FF;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.9,121.2h-43V74.6c0-11.9,9.6-21.5,21.5-21.5s21.5,9.6,21.5,21.5V121.2z M174.8,120.2h41.1V74.6 c0-11.3-9.2-20.5-20.5-20.5c-11.3,0-20.5,9.2-20.5,20.5V120.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.5047,
    y1: 114.2107,
    x2: 186.5047,
    y2: 100.1786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00309198,
    style: {
      stopColor: "#0023FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.2,114l-4.5-4.6c-1.2-1.2-1.1-3.3,0.3-4.3l8.1-6.4l-3.8,8.4l7.9,6.9H185.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.208,
    y1: 114.2107,
    x2: 204.208,
    y2: 100.1786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00309198,
    style: {
      stopColor: "#0023FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.5,114l4.5-4.6c1.2-1.2,1.1-3.3-0.3-4.3l-8.1-6.4l3.8,8.4l-7.9,6.9H205.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.9,88.2c-0.1,0-0.2,0-0.3-0.1l-0.2-0.2h-0.3c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h0.7l0.5,0.5 c0.2,0.2,0.2,0.5,0,0.7C204.2,88.2,204.1,88.2,203.9,88.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.9,90.2c-0.1,0-0.2,0-0.3-0.1l-0.5-0.5c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l0.5,0.5 c0.2,0.2,0.2,0.5,0,0.7C206.2,90.2,206.1,90.2,205.9,90.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.4,92.4c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0-0.7c-0.2-0.2-0.1-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0 l0.7,0.7l-0.8,0.7C207.6,92.3,207.5,92.4,207.4,92.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.1,100.1c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l0.8-0.6c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.2,0.1,0.5-0.1,0.7l-0.8,0.6C198.3,100,198.2,100.1,198.1,100.1z M201.2,97.5c-0.1,0-0.3-0.1-0.4-0.2 c-0.2-0.2-0.1-0.5,0.1-0.7l0.8-0.6c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7l-0.8,0.6C201.4,97.5,201.3,97.5,201.2,97.5z  M204.3,94.9c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l0.8-0.6c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7 l-0.8,0.6C204.5,94.9,204.4,94.9,204.3,94.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.4,102.5l-0.7-0.6c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1l0.1,0.1l0.1-0.1 c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7L195.4,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.9,100.1c-0.1,0-0.2,0-0.3-0.1l-0.8-0.6c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1l0.8,0.6 c0.2,0.2,0.2,0.5,0.1,0.7C193.2,100,193,100.1,192.9,100.1z M189.8,97.5c-0.1,0-0.2,0-0.3-0.1l-0.8-0.6c-0.2-0.2-0.2-0.5-0.1-0.7 c0.2-0.2,0.5-0.2,0.7-0.1l0.8,0.6c0.2,0.2,0.2,0.5,0.1,0.7C190.1,97.4,189.9,97.5,189.8,97.5z M186.7,94.9c-0.1,0-0.2,0-0.3-0.1 l-0.8-0.6c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1l0.8,0.6c0.2,0.2,0.2,0.5,0.1,0.7C187,94.9,186.8,94.9,186.7,94.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.3,92.4c-0.1,0-0.2,0-0.1-0.1l-0.8-0.7l0.5-0.7c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7 c0.2,0.2,0.2,0.5,0,0.7C183.6,92.3,183.5,92.4,183.3,92.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.8,90.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l0.5-0.5c0.2-0.2,0.5-0.2,0.7,0 c0.2,0.2,0.2,0.5,0,0.7l-0.3,0.5C185.3,90.2,184.9,90.2,184.8,90.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187,88.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l0.5-0.5h0.7c0.3,0,0.5,0.2,0.5,0.5 c0,0.3-0.2,0.5-0.5,0.5h-0.3l-0.2,0.2C187.3,88.2,187.1,88.2,187,88.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.2,87.9h-1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5 C200.7,87.6,200.5,87.9,200.2,87.9z M196.1,87.9h-1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5 C196.6,87.6,196.4,87.9,196.1,87.9z M192,87.9h-1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5 C192.5,87.6,192.3,87.9,192,87.9z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M188.1,251.8c-1.4-5.9-4.9-11.2-10-14.2c-7.7-4.5-21.1-1.1-26.1,6.2c-3.1-4.9-8.1-8.6-13.7-10 c-5.6-1.4-12.7-1-17.8,1.9c-0.7-6.9-5.2-13.2-11.5-16.1c-6.2-2.9-15.4-2.8-21.1,1c-0.4-3.5-3.1-6.6-6.5-7.5 c-3.4-0.9-8.5,0.3-10.6,3.1c-7.8-3.6-17.5-2.6-24.5,2.3c-7,5-11.2,13.8-10.4,22.3c-4.5-1.1-9.6,0.1-13.1,3.1c-2.3,2-4,4.8-4.7,7.8 H188.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.1588,
    y1: 241.1646,
    x2: 141.1752,
    y2: 201.8325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00942211,
    style: {
      stopColor: "#7DCEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    style: {
      stopColor: "#E4ABF9"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M148,232.2c1.7,2.7,5.2,3.9,7.3,6.2c1.9,2,2.7,4.8,3.3,7.4c0.5,2,0.9,4.1,1.8,6H177c0.6-1,0.9-2.1,1-3.4 c0.4-6.5-5.9-11.3-7.9-17.5c-0.8-2.6-0.9-5.4-1.3-8.1c-0.4-2.7-1.4-5.5-3.5-7.2c-2.6-2-6.5-2.2-8.2-5c-1.7-2.7-0.2-6.5-1.8-9.2 c-1.3-2.2-4.4-3.1-6.8-2c-2.4,1.1-3.8,3.7-3.8,6.3c0,3.6,2.6,6.8,3.2,10.4C148.7,221.5,145.1,227.6,148,232.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.6,217.5l-3.2-1.5c-0.2-0.1-0.5,0-0.6,0.2c-0.1,0.2,0,0.5,0.2,0.6l4.1,2l6.1,15.6l-6.7-4.4 c-0.2-0.1-0.5-0.1-0.7,0.1c-0.1,0.2-0.1,0.5,0.1,0.7l7.8,5.2l6.3,15.9c0,0,0,0,0,0h0.9c0-0.1,0.1-0.2,0-0.4l-10.1-25.7l1.8-7.2 c0.1-0.3-0.1-0.5-0.3-0.6c-0.3-0.1-0.5,0.1-0.6,0.3l-1.4,5.9l-5.8-14.7l1.3-4.3c0.1-0.3-0.1-0.5-0.3-0.6 c-0.3-0.1-0.5,0.1-0.6,0.3l-1,3.2l-1.3-3.2c-0.1-0.2-0.4-0.4-0.6-0.3c-0.2,0.1-0.4,0.4-0.3,0.6L154.6,217.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.2714,
    y1: 234.1635,
    x2: 148.5977,
    y2: 242.4407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00942211,
    style: {
      stopColor: "#817EF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    style: {
      stopColor: "#E4ABF9"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M154.2,251.8C154.2,251.8,154.2,251.8,154.2,251.8l16.8,0c0-0.9-0.1-1.9-0.4-3.1c-0.9-3.2-3.6-5.5-6.3-7.3 c-2.8-1.8-5.8-3.3-8.2-5.6c-1.8-1.8-3.2-4-5.5-5c-2.2-1-5-0.6-7-1.9c-1.5-1-2.2-2.8-3.4-4.2c-1.1-1.4-3.1-2.5-4.7-1.5 c-2.9,1.8-0.3,7.3,1.6,8.8c1.1,0.9,2.5,1.7,3.2,3c1,1.8,0.7,4.2,1.8,5.9c1.4,2.3,4.5,2.8,6.9,4 C151.9,246.3,152,249.5,154.2,251.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M164.9,250.5c-5.1-3.4-9.9-7.2-14.5-11.2l-0.4-4.9c0-0.3-0.3-0.5-0.5-0.4c-0.3,0-0.5,0.3-0.4,0.5l0.4,3.9 c-4-3.6-7.7-7.4-11.2-11.4c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7c2.2,2.5,4.5,4.9,6.9,7.3h-1.3c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5h2.3c1.4,1.4,2.9,2.7,4.3,4c0,0,0,0,0.1,0.1c2.1,1.9,4.4,3.7,6.6,5.5l-2.4,0.9c-0.2,0.1-0.4,0.4-0.3,0.6 c0.1,0.2,0.3,0.3,0.4,0.3c0.1,0,0.1,0,0.2,0l3-1.1c2.4,1.8,4.8,3.5,7.2,5.2c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.3-0.1,0.4-0.2 C165.2,251,165.1,250.7,164.9,250.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.2972,
    y1: 257.5137,
    x2: 246.7021,
    y2: 213.4611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00942211,
    style: {
      stopColor: "#8339BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M250.2,208.2c-2-1.3-4.9-1.1-6.7,0.5c-3.2,2.8-2.3,8.5-5.6,11.2c-3.2,2.6-8.1,0.8-11.7,2.7 c-5.1,2.7-4.4,10.8-8.9,14.4c-2.4,1.9-5.6,2.1-8.3,3.6c-2.7,1.4-4.7,4.1-5.2,7.1c-0.2,1.1-0.2,2.6,0,4.1H228 c4.6-3.7,3.4-12.4,8.4-15.9c2.1-1.4,5.1-1.6,6.8-3.6c2.3-2.6,1.2-6.7,2.7-9.9c1.5-3.1,5.4-4.7,6.5-8 C253.2,212.3,252.2,209.6,250.2,208.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M249.1,212.1c-0.2-0.1-0.4-0.1-0.6,0c-1.6,1.8-3.3,3.5-5,5.3V213c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4v5.2c-4.9,5.1-10,10.2-14.9,15.1l-3.8,3.8v-5.9c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4v6.7 l-13.9,13.9h1.1l17.9-17.9c1.4-1.4,2.8-2.8,4.2-4.2h4.2c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-3.4 c3.3-3.4,6.7-6.8,10-10.2c0,0,0,0,0,0c1.9-2,3.8-4,5.6-6C249.3,212.5,249.3,212.2,249.1,212.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.6869,
    y1: 228.0697,
    x2: 222.9781,
    y2: 254.7218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00942211,
    style: {
      stopColor: "#817EF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    style: {
      stopColor: "#E4ABF9"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M249.9,228.3c-1.2-1-3-0.5-4.2,0.4c-1.2,0.9-2.1,2.2-3.4,3.1c-3.6,2.5-9.2,1-12.2,4.1c-1.9,2-2,5.1-3.5,7.5 c-1.4,2.3-4,3.7-6.4,4.9c-2.1,1-4.4,2-6.1,3.6h22.1c0.3-0.1,0.5-0.2,0.8-0.4c2.4-1.4,4.4-4.1,5.4-6.7c1-2.7,1.2-5.9,3.1-8.1 c1.2-1.4,2.9-2.2,4.1-3.5C250.7,231.8,251.3,229.4,249.9,228.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M245.4,232.1c-0.2-0.2-0.4-0.2-0.6,0c-3.2,3.2-6.4,6.4-9.7,9.5v-3.5c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4v4.3c-0.4,0.3-0.7,0.7-1.1,1v-1.3c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4v2 c-2.9,2.6-5.8,5.2-8.7,7.7h1.2c1.5-1.3,3.1-2.6,4.6-4h7.4c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-6.5 c0.9-0.8,1.8-1.6,2.7-2.5c0,0,0,0,0.1-0.1c0.6-0.6,1.2-1.1,1.9-1.7c0,0,0,0,0,0c1.7-1.6,3.4-3.2,5.1-4.8h2.3 c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-1.5c1.5-1.5,3-3,4.5-4.5C245.5,232.5,245.5,232.3,245.4,232.1z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.8909,
    y1: 241.0203,
    x2: 218.0957,
    y2: 93.6743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00309198,
    style: {
      stopColor: "#5C00A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M229,247.4h-7.1c-10.2,0-9.8-8.2-18.7-8.2V128.1h-15.7v111.2c-8.9,0-8.5,8.2-18.7,8.2h-7.1 c-2.4,0-4.4,2-4.4,4.4h38h38C233.4,249.4,231.4,247.4,229,247.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.2919,
    y1: 86.3594,
    x2: 21.2868,
    y2: 367.6313,
    gradientTransform: "matrix(1 0 0 1 -5.2391 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00309198,
    style: {
      stopColor: "#0023FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M65.4,250.9l26.1-114c0.1-0.4,0.5-0.8,0.9-0.8c0.6-0.1,1.2,0.4,1.2,1.1l-0.1,113.8h15l-3.3-4.3 c0,0,3.8-69.6,1.2-119.4l-26.9,0.5L54.7,246.6l-6.2,4.3H65.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.9986,
    y1: 101.1299,
    x2: 154.0263,
    y2: 83.9051
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00942211,
    style: {
      stopColor: "#7DCEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    style: {
      stopColor: "#E4ABF9"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 139.9,
    y: 89.7,
    className: "st12",
    width: 8.8,
    height: 4.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.9064,
    y1: 87.5079,
    x2: 138.9064,
    y2: 102.3342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF576"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M139.9,89.7c0,0,2.9-0.1,2.9-1c0-0.9-4.9-1.2-5.7-1.3c-0.8-0.1-5.7,7.8-5.7,7.8l2.8,3.5l3.9-4.1 c1.4,0.1,8.1-0.6,8.1-0.6L139.9,89.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.7994,
    y1: 69.5887,
    x2: -17.2056,
    y2: 350.8603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00309198,
    style: {
      stopColor: "#0023FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M131.6,93.2L119,106.5l-10.3-22.3c-0.9-2.4-3.4-3.8-5.9-3.3l-38.7,6.6l13.7-18.7l-6.9-5 c0,0-18.8,24.5-18.9,29.7c-0.1,5.2,21.2,2.6,27.6,2l-0.1,32.2l26.9-0.5l1.2-24.1c3,5.6,6.6,14.4,9.8,14 c6.2-0.7,19.3-18.2,19.3-18.2L131.6,93.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.924,
    y1: 203.26,
    x2: 571.6555,
    y2: -1.8847,
    gradientTransform: "matrix(-1 0 0 1 601.9413 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00942211,
    style: {
      stopColor: "#8339BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M91.2,78.9c0,0-1.7,0-2,1c-0.5,1.4,0.2,7.6,1.3,7.5c1,0,3.8-4.3,3.8-4.3s4.1,3.3,5,2.6 c0.9-0.6-1.7-7.9-3.8-7.4C93.4,78.7,91.2,78.9,91.2,78.9z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M93.8,82.6c-0.9,0.1-1.7,0.1-2.3-0.6c-1.2-1.3-1.1-3.3-2.4-4.6c-0.6-0.6-1.3-1.1-1.9-1.6 c-1-0.8-1.6-2-2.1-3.1c-2.5-5.2-2.8-17.1,5.5-17.7c8.3-0.6,9.7,8.7,9.7,13c0,1.7-0.1,3.5-0.6,5.1c-0.3,0.8-0.7,1.6-1.3,2.3 c-0.7,0.7-1.5,1-2.2,1.6c-1,0.8-0.4,2.3-0.3,3.4C96,81.7,95.2,82.4,93.8,82.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 82.8,
    cy: 69.5,
    r: 2.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 101,
    cy: 67.4,
    r: 2.4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 92,
    cy: 67.2,
    r: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9923 -0.124 0.124 0.9923 -8.2213 12.1613)",
    className: "st18",
    cx: 93.6,
    cy: 72.1,
    rx: 0.8,
    ry: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 96.5,
    cy: 66.8,
    r: 0.8
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.8,70.4c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2c0.8,0,1.4-0.2,1.5-0.3c0-0.3-0.6-0.7-1.1-0.9 c-0.1,0-0.1-0.1-0.1-0.2l-0.5-2c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.3,0.1,0.3,0.2l0.4,1.9c0.4,0.2,1.2,0.7,1.3,1.2 c0,0.1,0,0.3-0.1,0.4C95.2,70.4,94,70.4,93.8,70.4C93.8,70.4,93.8,70.4,93.8,70.4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M100.4,68.6c-0.1,0-0.2-0.1-0.2-0.2c0-1,0.6-2,1.4-2.4c0.1-0.1,0.3,0,0.3,0.1c0.1,0.1,0,0.3-0.1,0.3 c-0.7,0.4-1.2,1.2-1.2,2C100.7,68.5,100.6,68.6,100.4,68.6C100.4,68.6,100.4,68.6,100.4,68.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M101.8,68c-0.1,0-0.2,0-0.2-0.1c-0.1-0.2-0.4-0.4-0.7-0.3c-0.1,0-0.3-0.1-0.3-0.2c0-0.1,0.1-0.3,0.2-0.3 c0.4,0,0.9,0.2,1.1,0.6c0.1,0.1,0,0.3-0.1,0.3C101.9,68,101.8,68,101.8,68z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M83.9,70.2C83.8,70.2,83.8,70.2,83.9,70.2c-0.2-0.1-0.3-0.2-0.2-0.3c0.2-0.4,0-0.9-0.4-1.1 c-0.4-0.2-0.9-0.1-1.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0.4-0.6,1.2-0.8,1.8-0.5c0.6,0.3,0.9,1.1,0.7,1.7 C84,70.1,84,70.2,83.9,70.2z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M96.6,64c-0.8,0-1.7-0.4-2.3-1c-0.1-0.1-0.1-0.3,0-0.3c0.1-0.1,0.3-0.1,0.3,0c0.6,0.7,1.6,1,2.4,0.8 c0.1,0,0.3,0.1,0.3,0.2c0,0.1-0.1,0.3-0.2,0.3C97,64,96.8,64,96.6,64z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M89.2,65.7c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.3,0.2-0.3c1.1-0.2,2.1-1.1,2.4-2.2c0-0.1,0.2-0.2,0.3-0.2 c0.1,0,0.2,0.2,0.2,0.3C91.7,64.5,90.5,65.5,89.2,65.7C89.2,65.7,89.2,65.7,89.2,65.7z"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M76.9,68c0,0,5.7-3.9,6-5.5c0.3-1.6-2.7,0.4-2.7,0.4s5.2-7.6,4.3-7.7s-2.9,2.4-2.9,2.4s1.5-3.6,1-3.7 C82,53.7,79.8,56,79.8,56s1.8-3.1,0.9-3.2c-0.9-0.1-4.5,4.7-4.5,4.7s1-3.3,0.5-3.1c-0.6,0.1-5,9.9-5,9.9L76.9,68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.048,
    y1: 68.8083,
    x2: 96.7216,
    y2: 42.2325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00309198,
    style: {
      stopColor: "#0023FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M102.9,54.1l-3.1,1.4c0,0,5.5-5.6-1-10.2l-6.2,7.3c0,0-5.4-0.2-8,1.5c-2.6,1.6-3.1,4.1-3.1,4.1l-2.2-1.7 l-0.7,1.9l2.4,0.3l-2,0.6l1.6,0.3c0,0-1.6,2-1.2,3.7c0.3,1.6,3.2,3.8,3.2,3.8s0.4-0.2,1,0.1c1.3,0.6,1.8,2.5,1.8,2.5l0.8-0.3 L85.7,65c0,0,2.9-0.1,2.9-4.2c0,0,4.4,2.3,7.6,0.3l-5-1.3c0,0,3,0.6,6-0.1c0.6,1.6,2.1,2.8,2.1,2.8l-0.2,4.2l0.9-0.2 c0.4-2.6-0.1-5.9-0.4-7.7C101.1,57.9,102.4,56.5,102.9,54.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.3564,
    y1: 130.1945,
    x2: 195.3564,
    y2: 107.8811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00309198,
    style: {
      stopColor: "#0023FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 185.2,
    y: 114,
    className: "st20",
    width: 20.3,
    height: 16
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M154.9,152.1c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.3,0.1,0.2,0.2c-0.1,0.1-0.2,0.2-0.4,0.2 C154.9,152.4,154.8,152.3,154.9,152.1z M157,152.5c0.1-0.1,0.2-0.2,0.2-0.4c-0.1-0.1-0.2-0.1-0.3,0c-0.1,0.1-0.3,0.1-0.2,0.2 S156.8,152.5,157,152.5z M165.1,145.9v17.4c0,0.9-0.8,1.7-1.7,1.7h-14.8c-0.9,0-1.7-0.8-1.7-1.7v-17.4c0-0.9,0.8-1.7,1.7-1.7h14.8 C164.4,144.1,165.1,144.9,165.1,145.9z M158.5,162.4c0-0.2-0.1-0.3-0.3-0.3h-4.4c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h4.4 C158.4,162.6,158.5,162.5,158.5,162.4z M161.9,161.3c0-0.2-0.1-0.3-0.3-0.3h-11.3c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3 h11.3C161.8,161.6,161.9,161.5,161.9,161.3z M154.3,153.7c0.4,0.9,1,1.5,1.7,1.5c0.7,0,1.3-0.7,1.7-1.5c-0.4,0.7-1,1.2-1.7,1.2 C155.3,154.9,154.7,154.4,154.3,153.7z M156,152.7c0.1,0,2.6,0.7,2.1-0.9c-0.3-0.9-1.6,0-2.1,0c-0.5,0-1.7-0.9-2.1,0 C153.4,153.4,155.9,152.7,156,152.7z M153.5,158.9c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h5c0.3,0,0.5-0.2,0.5-0.5 c0-0.3-0.2-0.5-0.5-0.5H153.5z M163,153.1c0-3.9-3.1-7-7-7c-3.9,0-7,3.1-7,7c0,1.5,0.5,2.9,1.3,4l3-1.7l0.8-0.8v-1.4 c-0.2,0.1-0.5,0.2-0.8-0.1c-0.4-0.4-0.4-1-0.1-1.2c0.2-0.2,0.5-0.1,0.6,0c-0.2-0.4-0.3-0.9-0.3-1.2c-0.1-0.7,0.3-0.8,0.4-0.8 c0,0,0-1.1,1.2-1.6c1.2-0.5,3,0.2,3.3,0.4l-0.4,0.4l0.8,0.5c0,0-0.1,0.2-0.4,0.2c0,0,0.2,0.3,0.3,0.6c0,0.2-0.1,0.9-0.3,1.4 c0.2-0.1,0.5-0.2,0.6,0c0.2,0.2,0.2,0.8-0.1,1.2c-0.2,0.3-0.6,0.2-0.8,0.1v1.4l0.8,0.8l3,1.7C162.5,156,163,154.6,163,153.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 697.7808,
    y1: 239.7624,
    x2: 718.9855,
    y2: 92.4168,
    gradientTransform: "matrix(-1 0 0 1 900.3442 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00309198,
    style: {
      stopColor: "#0023FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 169.9,
    y: 130.3,
    className: "st21",
    width: 51,
    height: 118.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.3563,
    y1: 129.5879,
    x2: 195.3563,
    y2: 138.0438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB325"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDA76"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166.2,
    y: 127,
    className: "st22",
    width: 58.3,
    height: 8.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.6437,
    y1: 139.3728,
    x2: 196.6144,
    y2: 121.3242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF576"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M235.3,118.4h-79.9c-4.8,0-8.6,3.9-8.6,8.6c0,4.8,3.9,8.6,8.6,8.6c3.5,0,6.5-2.1,7.9-5.1h64.2 c1.4,3,4.4,5.1,7.9,5.1c4.8,0,8.6-3.9,8.6-8.6C244,122.3,240.1,118.4,235.3,118.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "76,83.9 85.2,82.2 85.7,87.8 77,88.7 73.1,87.4  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "100.5,83.8 100.2,80 108.5,80 110.6,82.2 107.1,84.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.7487,
    y1: 174.4217,
    x2: 260.964,
    y2: 174.4217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00942211,
    style: {
      stopColor: "#7DCEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    style: {
      stopColor: "#E4ABF9"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M258.7,162.5c-15.9,15.4-39,23.7-63.4,23.7c-24.4,0-47.5-8.4-63.4-23.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.4956,
    y1: 160.847,
    x2: 129.4956,
    y2: 280.9268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF576"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 160.1,
    className: "st26",
    width: 4.9,
    height: 91.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.7658,
    y1: 161.6464,
    x2: 131.74,
    y2: 150.7285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF576"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 129.5,
    cy: 156.9,
    r: 5.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 639.1271,
    y1: 160.847,
    x2: 639.1271,
    y2: 280.9268,
    gradientTransform: "matrix(-1 0 0 1 900.3442 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF576"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 258.7,
    y: 160.1,
    className: "st28",
    width: 4.9,
    height: 91.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 637.3974,
    y1: 161.6464,
    x2: 641.3715,
    y2: 150.7285,
    gradientTransform: "matrix(-1 0 0 1 900.3442 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF576"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st29",
    cx: 261.2,
    cy: 156.9,
    r: 5.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.323,
    y1: 92.0601,
    x2: 151.8317,
    y2: 91.4001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB325"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFDA76"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M150.4,95L150.4,95c1.6,0,2.9-1.3,2.9-2.9v-0.6c0-1.6-1.3-2.9-2.9-2.9l0,0V95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.4668,
    y1: -138.5083,
    x2: 156.4942,
    y2: -155.7329,
    gradientTransform: "matrix(1 0 0 -1 0 -58.8983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00942211,
    style: {
      stopColor: "#7DCEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    style: {
      stopColor: "#E4ABF9"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148.7,
    y: 88,
    className: "st31",
    width: 3.5,
    height: 7.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.0909,
    y1: 113.4752,
    x2: 157.3146,
    y2: 252.0415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00309198,
    style: {
      stopColor: "#0023FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "74.8,123.1 77.9,123.4 70.6,162.7 67.4,161.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.9794,
    y1: 107.3711,
    x2: 165.2032,
    y2: 245.9376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00309198,
    style: {
      stopColor: "#0023FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#817EF9"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7,
    y: 127.6,
    className: "st33",
    width: 8.8,
    height: 3.7
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "239.3,44.5 235.4,40.6 242,33.9 234.5,26.5 219.7,41.2 220.9,42.4 216.9,44.1 224.3,51.6 226,47.6  227.2,48.7 233.8,42.1 238.4,46.7 246,46.7 246,44.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.9251,
    y1: 65.487,
    x2: 180.9485,
    y2: 2.5837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF576"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M151.3,16.7c-10.6,0-19.2,8.6-19.2,19.2c0,10.6,8.6,19.2,19.2,19.2c10.6,0,19.2-8.6,19.2-19.2 C170.5,25.3,161.9,16.7,151.3,16.7z M157,44.2c-1.1,1.1-2.5,1.9-4.2,2.2v1.4c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4v-1.4 c-1.4-0.2-2.6-0.7-3.6-1.4c-1-0.7-1.8-1.6-2.2-2.6c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.2,0-0.3,0.1-0.5c0.1-0.3,0.4-0.6,0.8-0.9 c0.3-0.1,0.5-0.2,0.7-0.2c0.5,0,1,0.3,1.5,1c0.9,1.5,2.5,2.3,4.4,2.3c1,0,2-0.3,2.7-0.8c0.8-0.5,1.3-1.3,1.3-2.2 c0-0.9-0.4-1.6-1.3-2.1c-0.6-0.3-1.2-0.5-2.2-0.8l-0.4-0.1c-2.2-0.4-3.9-1.1-5-2c-1.4-1.1-2-2.4-2-4.1c0-1.5,0.6-2.9,1.6-4 c1-1,2.4-1.7,3.9-2V24c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.7,0.1,1,0.4c0.3,0.3,0.4,0.6,0.4,1v1.2 c2.1,0.3,3.9,1.4,4.8,3c0.1,0.2,0.2,0.4,0.2,0.6c0,0.1,0,0.2,0,0.3c-0.1,0.3-0.2,0.6-0.4,0.8c-0.2,0.2-0.7,0.4-1.1,0.4 c-0.4,0-0.7-0.1-1-0.3c-0.7-0.6-1.3-1-1.7-1.2c-0.6-0.3-1.3-0.4-2.2-0.4c-1,0-1.9,0.3-2.6,0.7c-0.7,0.5-1.1,1.2-1.1,2 c0,0.9,0.5,1.5,1.4,2c0.8,0.4,1.7,0.6,3.3,1c1.8,0.5,3.2,1,4.2,1.9c1.3,1,1.9,2.4,1.9,4C158.7,41.6,158,43.1,157,44.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.9662,
    y1: 120.2683,
    x2: 286.9038,
    y2: 50.4849
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1247,
    style: {
      stopColor: "#ABDCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9976,
    style: {
      stopColor: "#EAEFFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M250.1,84.2c0.1-0.3,0.4-0.2,0.7-0.1c0.3,0.1,0.6,0.2,0.5,0.5c-0.1,0.3-0.5,0.5-0.8,0.4S250,84.5,250.1,84.2z  M254.8,85c0.3-0.1,0.5-0.5,0.4-0.8c-0.1-0.3-0.4-0.2-0.7-0.1c-0.3,0.1-0.6,0.2-0.5,0.5C254.1,85,254.5,85.1,254.8,85z M273.3,70.1 v39.3c0,2.1-1.7,3.9-3.9,3.9h-33.5c-2.1,0-3.9-1.7-3.9-3.9V70.1c0-2.1,1.7-3.9,3.9-3.9h33.5C271.6,66.2,273.3,67.9,273.3,70.1z  M258.2,107.4c0-0.4-0.3-0.6-0.6-0.6h-9.9c-0.4,0-0.6,0.3-0.6,0.6c0,0.4,0.3,0.6,0.6,0.6h9.9C258,108.1,258.2,107.8,258.2,107.4z  M266,105c0-0.4-0.3-0.6-0.6-0.6h-25.5c-0.4,0-0.6,0.3-0.6,0.6c0,0.4,0.3,0.6,0.6,0.6h25.5C265.7,105.7,266,105.4,266,105z  M248.8,87.8c0.9,1.9,2.2,3.4,3.8,3.4c1.5,0,2.9-1.5,3.8-3.4c-0.9,1.6-2.2,2.8-3.8,2.8C251.1,90.6,249.7,89.4,248.8,87.8z  M252.6,85.5c0.2,0.1,5.9,1.5,4.7-2c-0.7-2.1-3.6,0-4.7,0c-1.1,0-4-2.1-4.7,0C246.8,87,252.4,85.6,252.6,85.5z M247,99.6 c-0.6,0-1,0.5-1,1s0.5,1,1,1h11.3c0.6,0,1-0.5,1-1s-0.5-1-1-1H247z M268.5,86.4c0-8.8-7.1-15.9-15.9-15.9s-15.9,7.1-15.9,15.9 c0,3.4,1.1,6.6,2.9,9.2l6.8-4l1.8-1.8v-3.3c-0.5,0.2-1.2,0.4-1.8-0.2c-0.8-0.9-0.8-2.3-0.3-2.8c0.4-0.4,1.1-0.1,1.4,0 c-0.3-0.9-0.7-2-0.8-2.7c-0.2-1.6,0.6-1.9,0.9-1.9c0,0,0.1-2.4,2.8-3.6c2.7-1.2,6.7,0.5,7.5,1l-0.9,1l1.8,1.1c0,0-0.1,0.4-0.9,0.5 c0,0,0.5,0.6,0.6,1.3c0.1,0.4-0.3,2-0.6,3.2c0.3-0.1,1-0.4,1.4,0c0.5,0.5,0.5,1.8-0.3,2.8c-0.5,0.6-1.3,0.4-1.8,0.2v3.3l1.8,1.8 l6.8,4C267.4,93,268.5,89.8,268.5,86.4z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.9,70.8h-1.7V59.5c0-1.5-1.3-2.8-2.8-2.8c-1.5,0-2.8,1.3-2.8,2.8v2.9h-1.7v-2.9c0-2.5,2-4.5,4.5-4.5 c2.5,0,4.5,2,4.5,4.5V70.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.5,64.2h-8.4c-1,0-1.7,0.8-1.7,1.7v6.2c0,1,0.8,1.7,1.7,1.7h8.4c1,0,1.7-0.8,1.7-1.7v-6.2 C129.2,65,128.5,64.2,127.5,64.2z M123.8,69.4v1.1c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4v-1.1c-0.3-0.2-0.6-0.5-0.6-0.9 c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1C124.4,68.9,124.1,69.2,123.8,69.4z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M50.1,190.1c0,0.3-0.2,0.5-0.5,0.5l-4.4,0l0,4.4c0,0.3-0.2,0.5-0.5,0.5l-4.4,0l0,4.4c0,0.3-0.2,0.5-0.5,0.5 l-4.4,0l0,4.4c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5l0-4.9c0-0.3,0.2-0.5,0.5-0.5l4.4,0l0-4.4c0-0.3,0.2-0.5,0.5-0.5 l4.4,0l0-4.4c0-0.3,0.2-0.5,0.5-0.5l4.9,0C49.9,189.6,50.1,189.8,50.1,190.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.9,206l-7.4-1c-0.4,0-0.6-0.4-0.6-0.7l1-7.4c0-0.4,0.4-0.6,0.7-0.6l7.4,1c0.4,0,0.6,0.4,0.6,0.7l-1,7.4 C122.6,205.8,122.3,206.1,121.9,206z M115.4,203.8l6.1,0.8l0.8-6.1l-6.1-0.8L115.4,203.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M234.3,204.8c-0.1,0-0.2,0-0.3,0c-0.2-0.1-0.4-0.3-0.4-0.5l-1.3-7.8c0-0.2,0-0.5,0.2-0.6 c0.2-0.1,0.4-0.2,0.6-0.1l7.4,2.8c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2,0,0.5-0.2,0.6l-6.1,5C234.6,204.7,234.4,204.8,234.3,204.8z  M233.7,197.4l0.9,5.6l4.4-3.6L233.7,197.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.5,122.9c-0.1,0-0.2,0-0.3,0c-0.2-0.1-0.4-0.3-0.4-0.5l-1.3-7.8c0-0.2,0-0.5,0.2-0.6 c0.2-0.1,0.4-0.2,0.6-0.1l7.4,2.8c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2,0,0.5-0.2,0.6l-6.1,5C55.7,122.9,55.6,122.9,55.5,122.9z  M54.9,115.5l0.9,5.6l4.4-3.6L54.9,115.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.5,38.7c0,0.1-0.1,0.2-0.2,0.3c-0.2,0.1-0.4,0.2-0.6,0.1l-7.2-3.3c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.5,0.3-0.6l6.4-4.6c0.2-0.1,0.4-0.2,0.6-0.1c0.2,0.1,0.4,0.3,0.6,0.5l0.7,7.9C203.6,38.5,203.6,38.6,203.5,38.7z  M197,35l5.2,2.4l-0.5-5.6L197,35z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M154.4,67.1c-0.3-0.1-0.7,0.1-0.8,0.4l-0.8,2.6l-2.6-0.8c-0.3-0.1-0.7,0.1-0.8,0.4c-0.1,0.3,0.1,0.7,0.4,0.8 l2.6,0.8l-0.8,2.6c-0.1,0.3,0.1,0.7,0.4,0.8c0.3,0.1,0.7-0.1,0.8-0.4l0.8-2.6l2.6,0.8c0.3,0.1,0.7-0.1,0.8-0.4 c0.1-0.3-0.1-0.7-0.4-0.8l-2.6-0.8l0.8-2.6C155,67.5,154.8,67.2,154.4,67.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.9,53.8l-2.4-1.3l1.3-2.4c0.2-0.3,0-0.7-0.3-0.9c-0.3-0.2-0.7,0-0.9,0.3L63.4,52L61,50.7 c-0.3-0.2-0.7,0-0.9,0.3s0,0.7,0.3,0.9l2.4,1.3l-1.3,2.4c-0.2,0.3,0,0.7,0.3,0.9c0.3,0.2,0.7,0,0.9-0.3l1.3-2.4l2.4,1.3 c0.3,0.2,0.7,0,0.9-0.3C67.4,54.4,67.2,54,66.9,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.5,129.4l-2.5,1.1l-1.1-2.5c-0.2-0.3-0.5-0.5-0.9-0.3c-0.3,0.2-0.5,0.5-0.3,0.9l1.1,2.5l-2.5,1.1 c-0.3,0.2-0.5,0.5-0.3,0.9c0.2,0.3,0.5,0.5,0.9,0.3l2.5-1.1l1.1,2.5c0.2,0.3,0.5,0.5,0.9,0.3c0.3-0.2,0.5-0.5,0.3-0.9l-1.1-2.5 l2.5-1.1c0.3-0.2,0.5-0.5,0.3-0.9C267.2,129.3,266.8,129.2,266.5,129.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError1);
export default __webpack_public_path__ + "static/media/error1.d96ae717cd7ee26c58435456b5f91814.svg";
export { ForwardRef as ReactComponent };